// When changing card template image, just change ID of image (https://images.unsplash.com/{IMAGE-ID}?q=80&w=600&h=800)

export const CARDS_TEMPLATES = [
  {
    height: 256,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "text", "label"],
      design: "image-three",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Process Update",
      text: "Learn how we're simplifying workflows.",
      label: "Operations",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-9.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-9.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 256,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "text", "label"],
      design: "image-three",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "New Features",
      text: "See what's new in the latest platform update.",
      label: "Product",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Corporate Golf Cup Results",
      text: "Winners and key moments from the latest Corporate Golf Cup.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1597369237991-5c95d1b6e0c8?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1597369237991-5c95d1b6e0c8?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title"],
      design: "image-five",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Wishing everyone a sunny holiday!",
      text: "A warm seasonal message to brighten everyone's day and spread positive vibes across the team.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-3.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-3.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label"],
      design: "image-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Employee Onboarding",
      text: "Essential info to welcome and guide new team members.",
      linkText: "Read more",
      label: "HR Update",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-7.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-7.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "linkText"],
      design: "image-six",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Atlassian Team '24",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Read more",
      label: "Read more",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-2.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-2.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-four",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "New app feature release",
      text: "Overview of the latest feature and how it enhances the app experience.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-8.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-8.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "text", "label", "icon"],
      design: "image-eight",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Atlassian Team '24",
      text: "Getting ready for the event",
      linkText: "Read more",
      label: "Event",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: "atlaskit/CalendarIcon",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        id: "OHqbSPQC1qs",
      },
      imageSecond: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-2.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-2.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "image-four",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Dark Mode, Made Readable",
      text: "Apply your pre-defined dark mode colors.",
      linkText: "Read more",
      label: "Product",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-5.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-5.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "text"],
      design: "image-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Your Brand Colors or Ours",
      text: "Use your brand palette or pick from ours.",
      linkText: "Read more",
      label: "Product",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-6.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-6.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "linkText"],
      design: "image-seven",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Grab your popcorn and join us!",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "About movie night",
      label: "Team events",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-4.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-4.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "linkText"],
      design: "image-seven",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Meet your crew",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Explore profiles",
      label: "HR Update",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-10.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-10.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 107,
    config: {
      type: "image",
      columns: 2,
      layout: ["title", "arrow", "text"],
      design: "image-nine",
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "View your library",
      text: "Check library templates for a quick start",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1681287853913-3fd0d3f0be9c?q=80&w=200&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1681287853913-3fd0d3f0be9c?q=80&w=2487&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Big Wins",
      text: "Honoring the milestones and achievements",
      linkText: "Read more",
      label: "Team Success",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "New Courses",
      text: "Grow your expertise with our latest trainings.",
      linkText: "Read more",
      label: "Team Success",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "mortar_board",
        name: "Graduation Cap",
        short_names: ["mortar_board"],
        colons: ":mortar_board:",
        emoticons: [],
        unified: "1f393",
        skin: null,
        native: "🎓",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Big News",
      text: "Exciting updates about our company growth and new opportunities.",
      linkText: "Read more",
      label: "Company News",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "bell",
        name: "Bell",
        short_names: ["bell"],
        colons: ":bell:",
        emoticons: [],
        unified: "1f514",
        skin: null,
        native: "🔔",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "arrow"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Brand Launch",
      text: "Announcing the launch of a new brand identity with fresh visuals and messaging.",
      linkText: "Read more",
      label: "Company News",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "rocket",
        name: "Rocket",
        short_names: ["rocket"],
        colons: ":rocket:",
        emoticons: [],
        unified: "1f680",
        skin: null,
        native: "🚀",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["title"],
      design: "steps-two",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Define goals and success metrics.",
      text: "Begin the journey by exploring needs and possibilities. Understand challenges from every angle to create a strong foundation. Analyze, observe, and gather everything essential. Shape the path forward with curiosity, openness, and focus.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["title", "text", "arrow", "label"],
      design: "steps-three",
      format: "plainNumeric",
      prefix: "day",
      customPrefix: false,
      startWith: "1",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      text: "Lorem ipsum dolor sit amet consectetur eu neque non id.",
      linkText: "Learn more",
      label: "Learn more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["arrow", "linkText", "title"],
      design: "steps-one",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Attend onboarding training sessions.",
      text: "Schedule and details for required sessions to help new employees get started smoothly.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["title", "text"],
      design: "steps-two",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Launch kickoff meeting with all stakeholders.",
      text: "Start your project with clarity and momentum by following these key steps to ensure a smooth and successful launch.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["title", "text"],
      design: "steps-two",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Publish",
      text: "Make content live and accessible to your intended audience.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["arrow", "linkText", "title", "text"],
      design: "steps-one",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Publish",
      text: "Make content live and accessible to your intended audience.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["arrow", "linkText", "title", "text"],
      design: "steps-one",
      format: "paddedNumeric",
      startWith: "01",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Schedule launch",
      text: "Set timelines and key milestones to ensure a smooth and timely rollout.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "150%",
      text: "Increase in productivity.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "50+",
      text: "We've successfully delivered more than 50 campaigns, driving impactful results for our clients and stakeholders.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-three",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "50+",
      text: "We've successfully delivered more than 50 campaigns, driving impactful results for our clients and stakeholders.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "300",
      text: "Attendees who gained valuable insights at the event.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon"],
      design: "number-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "80%",
      text: "Progress indicator showing a task or project is nearly complete.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["text"],
      design: "number-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "$1.2M",
      text: "Revenue generated this quarter by sales team.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "atlassian-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office care",
      text: "Weekly stuff that needs to be taken care of to keep the office up and running",
      linkText: "Read more",
      label: "Office",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "label", "arrow"],
      design: "atlassian-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office care",
      text: "Make sure your bug reports are clear and actionable.",
      linkText: "Read more",
      label: "Office",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "label", "arrow", "text"],
      design: "atlassian-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office care",
      text: "Weekly stuff that needs to be taken care of to keep the office up and running",
      linkText: "Read more",
      label: "Office",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "arrow"],
      design: "atlassian-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office care",
      text: "Weekly stuff that needs to be taken care of to keep the office up and running",
      linkText: "Read more",
      label: "Office",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text"],
      design: "atlassian-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office care",
      text: "Weekly stuff that needs to be taken care of to keep the office up and running",
      linkText: "Read more",
      label: "Office",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-25.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-25.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "text",
      columns: 3,
      layout: ["icon", "title", "text", "linkText", "arrow"],
      design: "text-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Master Your Time",
      text: "Effective time management isn't just about getting more done—it's about creating space for what matters most. Learn strategies to prioritize, stay focused, and build better habits that drive both personal and team success.",
      linkText: "Productivity tips",
      label: "Productivity tips",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: "bootstrap/Clock",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "text",
      columns: 3,
      layout: ["title", "text", "label", "arrow"],
      design: "text-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "New Horizons",
      text: "We're expanding into exciting new markets and introducing innovative solutions to better serve our customers around the world. This next chapter represents more than growth — it's a chance to connect with new communities, build stronger partnerships, and deliver even greater value.",
      linkText: "Read more",
      label: "Expansion News",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: "bootstrap/Clock",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-11.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-11.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "text",
      columns: 3,
      layout: ["title", "text"],
      design: "text-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "June Company Highlights",
      text: "We’re proud to celebrate another year of incredible milestones and growth. Our teams across the world have worked together to achieve amazing results.",
      linkText: "Productivity tips",
      label: "Productivity tips",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: "bootstrap/Clock",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "text",
      columns: 3,
      layout: ["title", "text", "linkText"],
      design: "text-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Celebrating our sales success",
      text: "Thanks to the hard work, dedication, and collaboration across our teams, we've achieved outstanding sales results this quarter. Let's take a moment to recognize the milestones we've reached and the incredible momentum we've built for the future.",
      linkText: "Productivity tips",
      label: "Productivity tips",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: "bootstrap/Clock",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
];

export const HIDDEN_CARDS_TEMPLATE_STYLES = [];

export const OVERVIEW_CARDS_TEMPLATES = [
  {
    height: 256,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "text", "label"],
      design: "image-three",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "New Features",
      text: "See what's new in the latest platform update.",
      label: "Product",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "text"],
      design: "image-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Your Brand Colors or Ours",
      text: "Use your brand palette or pick from ours.",
      linkText: "Read more",
      label: "Product",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-6.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-6.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "text",
      columns: 3,
      layout: ["icon", "title", "text", "linkText", "arrow"],
      design: "text-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Master Your Time",
      text: "Effective time management isn't just about getting more done—it's about creating space for what matters most. Learn strategies to prioritize, stay focused, and build better habits that drive both personal and team success.",
      linkText: "Productivity tips",
      label: "Productivity tips",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: "bootstrap/Clock",
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-1.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "linkText"],
      design: "image-seven",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Meet your crew",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Explore profiles",
      label: "HR Update",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl: "https://caelor-apps.web.app/images/cover/card-10.jpg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/cover/card-10.jpg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Big Wins",
      text: "Honoring the milestones and achievements",
      linkText: "Read more",
      label: "Team Success",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
];

export const getCardsTemplates = ({
  cornerRadius,
  selectedColors = {},
  isInOverview = false,
}) =>
  (isInOverview ? OVERVIEW_CARDS_TEMPLATES : CARDS_TEMPLATES).map(
    (template) => ({
      ...template,
      config: {
        ...template.config,
        borderRadius: cornerRadius || 14,
      },
      card: {
        ...template.card,
        colors: {
          accent: {
            light:
              selectedColors?.accent?.light ||
              template.card.colors.accent.light ||
              "#000",
            dark:
              selectedColors?.accent?.dark ||
              template.card.colors.accent.dark ||
              "#FFF",
          },
          text: {
            light:
              selectedColors?.text?.light ||
              template.card.colors.text.light ||
              "#FFF",
            dark:
              selectedColors?.text?.dark ||
              template.card.colors.text.dark ||
              "#000",
          },
        },
      },
    })
  );
